import { render, staticRenderFns } from "./PcAlert.vue?vue&type=template&id=311ced52&scoped=true"
import script from "./PcAlert.vue?vue&type=script&lang=js"
export * from "./PcAlert.vue?vue&type=script&lang=js"
import style0 from "./PcAlert.vue?vue&type=style&index=0&id=311ced52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311ced52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
